module.exports = "/images/arrow-right-green.svg?e6c687ea173237d0aefb3994e0644ed2";